import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { getLegalPage } from '../lib/api';
import { SEO } from '../components/SEO';
import { ArrowLeft } from 'lucide-react';

export default function LegalPage() {
  const location = useLocation();
  const slug = location.pathname.replace(/^\//, '');
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getLegalPage(slug).then(res => { setPage(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center"><div className="animate-pulse text-slate-400">Loading...</div></div>;
  }

  if (!page) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
        <p className="text-slate-500">Page not found</p>
        <Link to="/" className="text-blue-600 hover:text-blue-700 text-sm font-medium">Return to Homepage</Link>
      </div>
    );
  }

  return (
    <div data-testid="legal-page">
      <SEO
        title={page.title}
        description={`${page.title} - MarketsReview.org legal information`}
        canonical={`/${slug}`}
        noindex={false}
      />
      <section className="bg-slate-900 text-white py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-xs text-slate-400 hover:text-slate-300 mb-4 transition-colors">
            <ArrowLeft className="w-3.5 h-3.5 mr-1" /> Home
          </Link>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight font-['Outfit']">{page.title}</h1>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article
          className="prose prose-slate prose-sm sm:prose-base max-w-none
            prose-headings:font-['Outfit'] prose-headings:tracking-tight
            prose-h2:text-2xl prose-h2:font-semibold prose-h2:text-slate-900 prose-h2:mt-8 prose-h2:mb-4
            prose-h3:text-lg prose-h3:font-medium prose-h3:text-slate-800 prose-h3:mt-6 prose-h3:mb-3
            prose-p:text-slate-700 prose-p:leading-relaxed
            prose-li:text-slate-700
            prose-strong:text-slate-900"
          dangerouslySetInnerHTML={{ __html: page.content }}
          data-testid="legal-content"
        />
      </div>
    </div>
  );
}
